var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Objet dynamique vectoriel2"),React.createElement("path",{"d":"M1331.53,1910c2.18,0,3.09,2.26,3.09,3.48,0,3.21-5.21,6.46-5.43,6.59a.66.66,0,0,1-.32.08.59.59,0,0,1-.31-.08,16,16,0,0,1-4.8-4.52c-.07-.12-.14-.26-.21-.4a3.94,3.94,0,0,1-.43-1.67c0-1.22.91-3.48,3.09-3.48,1.58,0,2.6,2,2.66,2h0c.06,0,1.08-2,2.66-2","transform":"translate(-1322.62 -1909.54)","style":{"fill":"none","stroke":"#233142","strokeLinecap":"round","strokeLinejoin":"round"},"key":1})]);
}

Heart.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 12.5 11.16"};

module.exports = Heart;

Heart.default = Heart;
